import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'angular-bootstrap-md';
import { Order } from 'src/app/models/Order';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { OrderService } from 'src/app/services/order.service';
import { CONSTANTES, getToken } from 'src/app/shared/global';
import { DataOrder } from 'src/app/models/DataOrder';
declare var jQuery: any;

@Component({
  selector: 'app-shipment-order',
  templateUrl: './shipment-order.component.html',
  styleUrls: ['./shipment-order.component.scss']
})
export class ShipmentOrderComponent implements OnInit {

  titulos: String[] = ['CIP', 'PEDIDO', 'FECHA SOLICITUD', 'FECHA ENVIO', 'REFERENCIA', ''];
  listOrders: Order[] = [];
  @ViewChild('shipmentModal') shipmentModal: ModalDirective;
  action: String;
  isData : boolean= false;
  indexOrder: number;
  dateSelect: Date;
  referenceSelect: String;

  constructor(private spinner: NgxSpinnerService, private toastr: ToastrService, private orderService: OrderService, private router: Router) { }
  

  ngOnInit() {
    this.spinner.show();
    jQuery.getScript(CONSTANTES.menu);

    this.orderService.getShipmentOrders().subscribe(
      data => {
        if (getToken(data)) {
          if(data!=null && data.orders!=null && data.orders.length>0){
            this.listOrders=data.orders;
            this.isData = true;
          }else{
            this.toastr.info("NO EXISTEN PEDIDOS QUE ENVIAR", "INFO");
            this.isData = false;
            this.router.navigate(['home']);
          }
          
        }
      },
      error => {
        this.spinner.hide();
        this.toastr.error("HA OCURRIDO UN ERROR AL CARGAR LOS DATOS", "ERROR");
      }  
    )

    this.spinner.hide();
  }

  edit(index: number){
    this.indexOrder = index;
    this.shipmentModal.show();
    this.dateSelect = this.listOrders[this.indexOrder].shipmentDate;
    this.referenceSelect = this.listOrders[this.indexOrder].shipmentReference;
  }

  insertDate(){
    this.listOrders[this.indexOrder].shipmentDate = this.dateSelect;
    this.listOrders[this.indexOrder].shipmentReference =  this.referenceSelect.toString();
    this.spinner.show();
    let dataOrder : DataOrder = new DataOrder();
    let listOrders2: Order[] = [];
    listOrders2.push(this.listOrders[this.indexOrder]);
    dataOrder.orders = listOrders2;
    this.orderService.setShipmentOrders(dataOrder).subscribe(
      data => {
        if (getToken(data)) {          
          //dataOrder= data;
          dataOrder.orders[this.indexOrder] = data.orders[0];
          this.spinner.hide();
          this.toastr.success("DATO PROCESADO CORRECTAMENTE", "INFO");
          this.listOrders=data.orders;
        }
      },
      error => {
        this.spinner.hide();
        this.toastr.error("HA OCURRIDO UN ERROR AL GUARDAR LOS DATOS", "ERROR");
      }  
    )
    this.closePreparationModal();
    this.spinner.hide();
  }

  insertData(){
    this.spinner.show();
    let dataOrder : DataOrder = new DataOrder();
    dataOrder.orders = this.listOrders.filter(check => {
       return check.shipment;
    });

    this.orderService.setShipmentOrders(dataOrder).subscribe(
      data => {
        if (getToken(data)) {
          this.toastr.success("DATOS PROCESADOS CORRECTAMENTE", "INFO");
          this.spinner.hide();
          this.router.navigate(['home']);
        }
      },
      error => {
        this.spinner.hide();
        this.toastr.error("HA OCURRIDO UN ERROR AL GUARDAR LOS DATOS", "ERROR");
      }  
    )

    //this.spinner.hide();
  }

  closePreparationModal(){
    this.shipmentModal.hide();
    this.shipmentModal.ngOnDestroy();
  }

  togglecheck(e, index:number){
    
    if(this.listOrders[index].shipmentDate!=null && this.listOrders[index].shipmentReference!=null){
      this.listOrders[index].shipment = e.target.checked;
    }else{
      e.target.checked = false;
      this.toastr.info("ES NECESARIO AÑADIR LA FECHA Y LA REFERENCIA PARA PODER CERRAR LA MANIPULACIÓN", "INFO");
    }
  }

}
